import { useCallback, useEffect, useState } from 'react';

import { isAgentReply } from 'components/Reply/reply-type';
import { useOnStateTransition } from 'hooks/useOnStateTransition';

export const LAST_MESSAGE_CHECK_TIMESTAMP_STORAGE_KEY =
  'getSupportLastMessageCheckTime';

const getStoredLastMessageCheckTime = () =>
  sessionStorage.getItem(LAST_MESSAGE_CHECK_TIMESTAMP_STORAGE_KEY);

const storeLastMessageCheckTime = (time) =>
  sessionStorage.setItem(LAST_MESSAGE_CHECK_TIMESTAMP_STORAGE_KEY, time);

const checkPanelOnClose = (previousOpenState, currentOpenState) =>
  previousOpenState === true && currentOpenState === false;

/*
 * Try to restore last message check time from storage, if none exists,
 * set a new one
 */
const initializeLastMessageCheckTime = () => {
  const lastCheckTime = new Date(
    parseInt(getStoredLastMessageCheckTime()),
  ).getTime();

  if (isNaN(lastCheckTime)) {
    const latestTime = new Date().getTime();

    storeLastMessageCheckTime(latestTime);

    return latestTime;
  }

  return lastCheckTime;
};

export const useCheckNewMessagesOnPanelClose = (
  isSupportPanelOpen,
  conversation,
) => {
  const [lastMessageCheckTime, setLastMessageCheckTime] = useState(
    initializeLastMessageCheckTime,
  );
  const [hasNewMessage, setHasNewMessage] = useState(false);

  /*
   * Save latest check time to storage and set state
   */
  const saveLatestMessageCheckTime = useCallback(() => {
    const latestTIme = new Date().getTime();

    storeLastMessageCheckTime(latestTIme);
    setLastMessageCheckTime(latestTIme);
  }, []);

  /*
   * Save latest message check time on panel closed
   */
  useOnStateTransition(
    isSupportPanelOpen,
    checkPanelOnClose,
    saveLatestMessageCheckTime,
  );

  /*
   * Check whether there is new message on panel close
   */
  useEffect(() => {
    if (isSupportPanelOpen) {
      setHasNewMessage(false);
    } else {
      const hasNewMessage = conversation.some(({ replyType, datetime }) =>
        isAgentReply(replyType)
          ? datetime.getTime() > lastMessageCheckTime
          : false,
      );

      setHasNewMessage(hasNewMessage);
    }
  }, [isSupportPanelOpen, conversation, lastMessageCheckTime]);

  return hasNewMessage;
};
